import { getRecipientWellsFromComposeViewState } from './getAllRecipientsAsEmailAddressStrings';
import getCurrentFromAddress from './getCurrentFromAddress';
import { infoBarAddHandler, infoBarRemoveHandler } from './infoBarHandlers';
import ComposeViewState from '../store/schema/ComposeViewState';
import { lazyRefreshSharingTipsAttachmentWell } from 'owa-attachment-well-data';
import { RecipientInfo } from 'owa-attachment-well-data';
import getMemberCountInfo, { MemberCountInfo } from 'owa-mail-tips/lib/utils/getMemberCountInfo';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import getRecipientsFromRecipientWells from 'owa-recipient-common/lib/utils/getRecipientsFromRecipientWells';

let refreshSharingTipsAttachmentWell;

export async function refreshSharingTips(viewState: ComposeViewState) {
    if (!refreshSharingTipsAttachmentWell) {
        refreshSharingTipsAttachmentWell = await lazyRefreshSharingTipsAttachmentWell.import();
    }

    const recipientWells = getRecipientWellsFromComposeViewState(viewState);

    const recipients = getRecipientsFromRecipientWells(recipientWells);
    const fromAddress: string = getCurrentFromAddress(viewState.toRecipientWell);
    const recipientInfo: RecipientInfo[] = getRecipientsInfo(recipients, fromAddress);

    refreshSharingTipsAttachmentWell(
        viewState.attachmentWell,
        viewState.itemId,
        recipientInfo,
        viewState.infoBarIds.slice(),
        infoBarAddHandler(viewState),
        infoBarRemoveHandler(viewState)
    );
}

function getRecipientsInfo(
    recipients: ReadWriteRecipientViewState[],
    fromAddress: string
): RecipientInfo[] {
    let recipientsInfo: RecipientInfo[] = [];
    recipients.forEach(recipient => {
        const persona: FindRecipientPersonaType = recipient.persona;
        const memberCountInfo: MemberCountInfo = getMemberCountInfo(
            fromAddress,
            persona.EmailAddress.EmailAddress
        );
        if (memberCountInfo !== null) {
            recipientsInfo.push({
                emailAddress: persona.EmailAddress.EmailAddress,
                ADObjectId: persona.ADObjectId,
                totalMemberCount: memberCountInfo.TotalMemberCount,
                externalMemberCount: memberCountInfo.ExternalMemberCount,
                name: persona.EmailAddress.Name,
                MailboxType: persona.EmailAddress.MailboxType,
                RoutingType: persona.EmailAddress.RoutingType,
            });
        }
    });

    return recipientsInfo;
}
